import CaseFolders from "../CaseFolders";

import Notifications from "../Notifications";
import Overview from "../Overview";

import Settings from "../Settings";

import ViewCaseFolder from "../case-folder/ViewCaseFolder";
import ScheduleCaseHearing from "../case-folder/ScheduleCaseHearing";

import JoinderRequest from "../JoinderRequest";
import PanelsDocket from "../PanelsDocket";
import CauseLists from "../CauseLists";
import ScheduleHearing from "../cause-list/ScheduleHearing";
import CourtStaff from "../CourtStaff";
import ViewJoinderFolder from "../ViewJoinderFolder";

export const PanelRoute = [
  {
    title: "Overview",
    path: "/panel/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/panel/case-folders",
    component: CaseFolders,
  },

  {
    title: "View Case Folder",
    path: "/panel/case-folders/view",
    component: ViewCaseFolder,
  },
  {
    title: "Schedule Hearing",
    path: "/panel/case-folders/schedule-hearing",
    component: ScheduleCaseHearing,
  },
  {
    title: "Court Staff",
    path: "/panel/court-staff",
    component: CourtStaff,
  },
  {
    title: "Joinder Request",
    path: "/panel/joinder-request",
    component: JoinderRequest,
  },
  {
    title: "View Joinder Request",
    path: "/panel/joinder-request/view",
    component: ViewJoinderFolder,
  },

  {
    title: "Court Staff",
    path: "/panel/court-staff",
    component: CourtStaff,
  },
  {
    title: "Docket",
    path: "/panel/panels/docket",
    component: PanelsDocket,
  },
  {
    title: "Cause Lists",
    path: "/panel/cause-lists",
    component: CauseLists,
  },
  {
    title: "Schedule Hearing",
    path: "/panel/cause-lists/schedule",
    component: ScheduleHearing,
  },

  {
    title: "Notification",
    path: "/panel/notification",
    component: Notifications,
  },
  {
    title: "Setting",
    path: "/panel/setting",
    component: Settings,
  },
];
